import { defineComponent as _defineComponent } from 'vue'
import { LegacyRoccSeverity } from '@/ui/components/inspectionReport/legacyTypes';
  import { ref, watch } from 'vue';
  import DeleteButton from '@/_legacy/components/DeleteButton';
  import { DropdownField } from '@/ui/components/form';
  import { ResourceTable } from '@/ui/components/table/ResourceTable';
  import { cloneDeep } from 'lodash/fp';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'RoccSeverityEditor',
  props: {
    severities: {
      type: Array as () => LegacyRoccSeverity[],
      default: () => [],
    },
    categories: {
      type: Array as () => Array<{ value: number }>,
      default: () => [],
    },
  },
  emits: ['update:severities'],
  setup(__props, { emit }) {

const props = __props;

  

  

  const localSeverities = ref<LegacyRoccSeverity[]>([]);

  watch(
    () => props.severities,
    (newVal: LegacyRoccSeverity[]) => {
      localSeverities.value = newVal ? cloneDeep(newVal) : [];
    },
    { immediate: true },
  );

  const getFilteredCategories = (category: number | null) => {
    const selectedCategories = localSeverities.value.map(severity => severity.category);

    return props.categories.filter(cat => cat.value === category || !selectedCategories.includes(cat.value));
  };

  const handleCategorySelect = (index: number, event: number) => {
    localSeverities.value[index].category = event;
    emit('update:severities', cloneDeep(localSeverities.value));
  };

  const handleThresholdUpdate = (index: number, event: number) => {
    localSeverities.value[index].threshold = event;
    emit('update:severities', cloneDeep(localSeverities.value));
  };

  const deleteSeverity = (index: number) => {
    localSeverities.value.splice(index, 1);
    emit('update:severities', cloneDeep(localSeverities.value));
  };

  const addSeverityLevel = () => {
    localSeverities.value.push({ category: null, threshold: 1 });
    emit('update:severities', cloneDeep(localSeverities.value));
  };

return { __sfc: true,props, emit, localSeverities, getFilteredCategories, handleCategorySelect, handleThresholdUpdate, deleteSeverity, addSeverityLevel, DeleteButton, DropdownField, ResourceTable }
}

})